import { render, staticRenderFns } from "./holidayActFemaleRank.vue?vue&type=template&id=251d906e&scoped=true"
import script from "./holidayActFemaleRank.vue?vue&type=script&lang=js"
export * from "./holidayActFemaleRank.vue?vue&type=script&lang=js"
import style0 from "./holidayActFemaleRank.vue?vue&type=style&index=0&id=251d906e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251d906e",
  null
  
)

export default component.exports